import { useLocale } from 'next-intl';
import { useParams } from 'next/navigation';

import { type Locale } from '@/i18n/routing';

import { useInfiniteLoader } from '@/hooks/useInfiniteLoader';

import { CollectionsApi } from '@/api/domains/collections.api';
import type { CollectionList } from '@/api/types/collections.types';

import { CollectionsQueryKeys } from '@/contexts/QueryContext/query.keys';

export const useCollections = () => {
  const { moduleId } = useParams() as { moduleId: string };
  const locale = useLocale() as Locale;

  const result = useInfiniteLoader<CollectionList, unknown>({
    queryKey: CollectionsQueryKeys.list(locale),
    queryFn: ({ pageParam = 1 }) =>
      CollectionsApi.fetchCollections({ page: pageParam, module_id: moduleId, items: 30 }),
    initialPageParam: 1,
  });

  return result;
};
